import React, { useEffect, useRef } from "react";
import Layout from "../../../components/vendor/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import Pagination from "../../../components/ui/Pagination";
import Button from "../../../components/ui/utils/Button";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/vendor/apiRequest";
import useModal from "../../../hooks/ui/useModal";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import CreateGallery from "../../../components/vendor/gallery/CreateGallery";
import EditGallery from "../../../components/vendor/gallery/EditGallery";
import DeleteGallery from "../../../components/vendor/gallery/DeleteGallery";
import Modal from "../../../components/ui/utils/Modal";
import InputField from "../../../components/ui/form/InputField";
import { getFileUrl } from "../../../utils/helper";

const GalleryList = () => {
  const {
    currentPage,
    data,
    error,
    fetchData,
    limit,
    loading,
    setPage,
    sort,
    setSorting,
    totalItems,
    totalPages,
    setFilters,
  } = usePaginate({
    apiMethod: apiRequest.getGallery,
    dataKey: "gallerys",
  });
  

  const { isOpen, openModal, closeModal, actionType } = useModal();

  const handleSort = (field) => {
    const order =
      sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
    setSorting({ sortField: field, sortOrder: order });
  };

  const searchRef = useRef("");
  const debounceRef = useRef(null);

  const handleSearch = (e) => {
    searchRef.current = e.target.value;
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      const filters = {};
      if (searchRef.current) {
        filters.name = { $regex: searchRef.current, $options: "i" };
      }
      setFilters(filters);
    }, 500);
  };

  return (
    <Layout>
      <Helmet>
        <title>Gallery</title>
      </Helmet>

      <div className="p-4 bg-white rounded">

        <div className="flex items-center justify-between py-2">
          <Button variant="primary" onClick={() => openModal({ type: "add" })}>
            <div className="flex gap-2 items-center">
              <FaPlus /> Add Media
            </div>
          </Button>
        </div>

        <InputField
          name="search"
          placeholder="Search by name"
          onChange={handleSearch}
        />

        <Table
          headers={[
            { label: "Type", key: "type", sorting: true },
            { label: "Name", key: "name", sorting: true },
            { label: "Media", key: "file", sorting: false },
            { label: "Created At", key: "createdAt", sorting: false },
            { label: "Actions", key: "action", sorting: false },
          ]}
          loading={loading}
          handleSort={handleSort}
          sort={sort}
          error={error}
          cols={4}
          renderRow={
            <tbody>
              {data?.map((item) => (
                <tr key={item._id} className="hover:bg-gray-50">
                  <td className="px-3 py-3">{item.type}</td>

                  <td className="px-3 py-3">{item.name || "-"}</td>

                  <td className="px-3 py-3">
                    <img
                     src={getFileUrl(item.file)}
                      className="w-20 h-20 object-cover border rounded"
                    />
                  </td>
                    <td className="px-3 py-3 text-xs text-gray-500">
                    {new Date(item.createdAt).toLocaleDateString("en-IN", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>

                  <td className="px-3 py-3">
                    <div className="flex gap-3 justify-center">
                      <button
                        className="text-primary"
                        onClick={() =>
                          openModal({
                            type: "edit",
                            data: { state: item },
                          })
                        }
                      >
                        <FaEdit size={18} />
                      </button>

                      <button
                        className="text-red-500"
                        onClick={() =>
                          openModal({
                            type: "delete",
                            data: { state: item },
                          })
                        }
                      >
                        <FaTrashAlt size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}
      </div>

      <Modal isOpen={isOpen} onClose={closeModal} size="lg">
        {actionType?.type === "add" && (
          <CreateGallery closeModal={closeModal} callback={fetchData} />
        )}

        {actionType?.type === "edit" && (
          <EditGallery
            data={actionType?.data?.state}
            closeModal={closeModal}
            callback={fetchData}
          />
        )}

        {actionType?.type === "delete" && (
          <DeleteGallery
            data={actionType?.data?.state}
            closeModal={closeModal}
            callback={fetchData}
          />
        )}
      </Modal>
    </Layout>
  );
};

export default GalleryList;
